import { Routine } from 'redux-saga-routines';
import {
  mergePositionsRoutine,
  checkPositionNameRoutine
} from './routines';

export type MergePositionsState = {
  isSaving: boolean;
  error: string | null;
  isNameTaken: boolean;
  isChecking: boolean;
};

const initialState: MergePositionsState = {
  isSaving: false,
  isNameTaken: false,
  isChecking: false,
  error: null
};

export const mergePositions = (
  state: MergePositionsState = initialState,
  { type, payload }: Routine<any>
): MergePositionsState => {
  switch (type) {
    case mergePositionsRoutine.TRIGGER:
      return {
        ...state,
        isSaving: true
      };
    case mergePositionsRoutine.SUCCESS:
      return {
        ...state,
        isSaving: false,
        error: null
      };
    case mergePositionsRoutine.FAILURE:
      return {
        ...state,
        isSaving: false,
        error: payload
      };
    case checkPositionNameRoutine.TRIGGER:
      return {
        ...state,
        isChecking: true
      };
    case checkPositionNameRoutine.SUCCESS:
      return {
        ...state,
        isChecking: false,
        isNameTaken: payload
      };
    case checkPositionNameRoutine.FAILURE:
      return {
        ...state,
        isChecking: false,
        error: payload
      };
    default:
      return state;
  }
};
